/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { setStep03, resetQuotes, setStep03Renewals, getRenewalVariation, getQuoteVariation } from '../../../actions'

/**
 * Import
 * - Page component
 */
import Step03 from '../../../components/pages/Quote/Step03/Step03'

const mapStateToProps = (state: RootState, props: any) => {
    return {
        quote: state.quote,
    }
}

export default connect(
    mapStateToProps,
    {
        setStep03: setStep03,
        setStep03Renewals: setStep03Renewals,
        resetQuotes: resetQuotes,
        getRenewalVariation,
        getQuoteVariation,
    }
)(Step03)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Quote/Step03.tsx